// src/app/core/interceptors/auth.interceptor.ts
import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { tap } from "rxjs";
import { AuthService } from "../services/auth.service";
import { buildSsoCheckLoginUrl } from "../utils/sso-redirect.util";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  if (token) {
    const authReq = req.clone({
      headers: req.headers.set("Authorization", `Bearer ${token}`),
    });
    return next(authReq);
  }

  return next(req);

  
};
export const requestInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    return next(req).pipe(
        tap({
          error: (err: unknown) => {
            if (!(err instanceof HttpErrorResponse)) return;
    
            const urlResponse = err.url ? new URL(err.url) : null;
    
            if (!urlResponse) return;

            const path = window.location.pathname;
            if (path.includes("/login") || path.includes("/index.php/unauth/login_sso_callback")) {
              return;
            }
            // 🔹 401
            if (err.status === 401) {
              if (authService.isMockAuthEnabled()) {
                return;
              }
              window.location.href = buildSsoCheckLoginUrl();
              return;
            }
          }
        })
    );
  };